import { Paper } from '@material-ui/core';
import styled from 'styled-components';

import { px } from '../../../../../contrib/ui';

export const EmptyTeamCard = styled(Paper)`
  min-height: ${px(300)} !important;

  border-color: var(--mainColor);
  border-width: 2px;
  border-style: dashed;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;

  span {
    font-family: 'DINNextLTPro-Bold';
    font-size: ${px(18)};
    display: inline-block;

    &:nth-of-type(1) {
      text-align: center;
      font-size: ${px(28)};

      width: ${px(30)};
      height: ${px(30)};

      margin-right: ${px(10)};

      background-color: var(--mainColor);
      color: white;
      border-radius: ${px(50)};
    }
    &:nth-of-type(2) {
      margin-top: ${px(5)};
      color: var(--mainColor);
    }
  }

  &:hover {
    background-color: inherit;
    cursor: pointer;
  }
`;
